import { reactive, toRefs, onMounted, nextTick, ref } from 'vue'
import { useStore } from 'vuex'
export default function useDealer() {
  const store = useStore()
  const useDealerRef = ref()
  const state = reactive({
    applyDealerParam: {}
  })
  const viewUseDealer = data => {
    // console.log('viewUseDealer---usejs', data)
    state.applyDealerParam = data
    nextTick(() => {
      useDealerRef.value.changeShowNUm()
    })
  }

  return {
    ...toRefs(state),
    useDealerRef,
    viewUseDealer
  }
}
